import { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CardActions from "@material-ui/core/CardActions";
import { DatePicker } from "@material-ui/pickers/DatePicker";
import CurrencyFormater from "../../../shared/ui/Currency.Input";
import _ from "underscore";
import TextField from "@material-ui/core/TextField";
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { accountingConnector } from "../../../services/accounting/connector";
import { compose } from "redux";

const AccountingSolvenComponent = ({
  changeSolvenPaidParts,
  getCreditByGuid,
  registerMPLRepayment,
  getOriginators,
  accounting: { solvenLoans },
}) => {
  const wrapperStyle = {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
  };
  const halfItemStyle = {
    minWidth: "450px",
    width: "50%",
    padding: "10px",
    boxSizing: "border-box",
  };
  const creditIds = [
    "0607ae59-5fcf-4fe4-a7e9-a615ceb98d57",
    "08a604ee-a6c3-4c96-abbe-e6315c0aa94d",
    "1307b53c-523c-4ef0-bf5f-0a5a65b5d728",
    "13a10717-0598-4c09-9e1c-43e06f21007e",
    "1477748a-d8d0-42d1-b9d4-668e1d5b9167",
    "1697f28c-f2a4-4f9a-9fe4-35b5f681cd51",
    "2d7d112b-8606-4ace-8962-b7c49867787e",
    "33691190-a9dc-472f-872d-4ac19e6c2e23",
    "349a12d2-8b7b-4314-8aff-faabb4875bcc",
    "35d28ff6-134c-4082-bd05-2420eb36884e",
    "3b2e65b5-fc41-4d55-8821-bf76cadce79b",
    "3e6656ff-1239-436c-99ed-3a959a735906",
    "407a9b6d-4cde-47d7-b593-b396934f3c44",
    "422ce516-c891-4ffd-ac8e-da87875eb402",
    "4e6d7825-0a7b-4da1-9cda-968d5b4f295f",
    "500b055d-d8c3-4f84-9f75-6320c7e18f84",
    "5d0e5d7b-8415-4f53-a23c-b61ced365255",
    "5d9f6833-de32-4612-8825-db0b99dd0aec",
    "646e426c-86a6-46d4-a1a2-927f40e8388d",
    "67776d7f-2814-4719-abf4-0bcaab66883c",
    "6a9b79e2-4092-474c-ba50-03cd606e9aef",
    "6b27f718-17fa-42f2-88c7-428aee9531fe",
    "788c6ca5-e635-4d59-9413-d70ba787bf03",
    "8a0bbb54-5eb5-4beb-9395-8eedd753bb6c",
    "943a5f19-6e30-4d7c-8424-3a5a8a5beac2",
    "9ec33b3a-4b58-4ffa-a9d4-b0133f42fdb6",
    "a034ff0f-b1b6-497a-8c8a-bbf83c11af25",
    "a0604e81-df1c-4058-8a7b-fd45990bbd0a",
    "a79416e9-1a48-423f-8d7c-523c00600c8f",
    "adbf11f3-1d75-4322-b584-5d671bdfbe78",
    "bf0e89a5-9677-45d3-82ac-d394a172945e",
    "f01d4342-cf15-4e41-b70d-51e4ef647616",
    "f318c67a-d69c-46dd-b4d6-8ab59c873f89",
    "f37a85b8-9acd-4d75-98af-e954f1733adf",
    "f4b3cacb-c200-4609-b3e4-50ca6fcfcd6a",
    "fe6ef239-29a5-4ddf-8cb2-f703b9c075db",
    "febdd83a-3927-4fa3-ad62-de026f26cb3d",
  ];
  // const creditIds = [ '008a8418-b642-4edd-b275-f5211e26bb71', '0392e4ed-2456-4b4c-940c-06774b73cef1', '05a9c12e-1ce3-454e-a6cc-77eacdc1e583', '0f5877b6-c6f1-4a2f-8286-0b301b9243a9',
  //   '13cd55e2-3d33-40cd-8e5d-9fb9c6872e86', '195a646c-33dd-4e02-8fae-23b918477de6', '36d86c76-03bc-4c09-a8d9-79d925dbc36d', '38788767-faaf-4f58-b54e-e3aa1153def2', '47253215-369c-4c78-987f-bed17c11f65b',
  //   '5d68b550-b692-4693-95e5-4ae07a2536c9', '5de244f7-e8d1-477a-af12-588f7c8f9e62', '6636219e-d8a8-418d-b1e0-7ed1eab56e87', '6c594266-398e-4b2c-a056-158fcd722669', '8e6be51e-2d78-4576-a2f8-6a4208f5f3d3',
  //   '92173a66-7dcc-43e5-a45c-1431cab16b2d', '93540f8e-bde4-484d-8228-da5167fc1b52', 'b6913278-c0ef-49a7-939c-9088427f35e4', 'd4e7a87e-adcf-4fbf-8e3a-cdfd8ec5e142', 'dd1eeaf2-eac6-4d32-9c0e-7b34ec947c7f',
  //   'e1fe019a-cf30-49b1-aede-e105e539e4e9', 'f76e23cc-bb87-4193-91ba-d7ef069f5764' ];

  const [interest, setInterest] = useState("");
  const [principal, setPrincipal] = useState("");
  const [fees, setFees] = useState("");
  const [date, setDate] = useState(new Date());
  const [number, setNumber] = useState("");
  const [creditEnded, setCreditEnded] = useState(false);

  let columns = [
    { key: "Id", label: "Id", visible: true, type: CELL_TYPES.text },
    {
      key: "RemainingAmount",
      label: "Remaining",
      visible: true,
      type: CELL_TYPES.text,
    },
    {
      key: "Principal",
      label: "Principal",
      visible: true,
      type: CELL_TYPES.text,
    },
    {
      key: "Interest",
      label: "Interest",
      visible: true,
      type: CELL_TYPES.text,
    },
    { key: "Fees", label: "Fees", visible: true, type: CELL_TYPES.text },
  ];

  useEffect(() => {
    for (let id of creditIds) getCreditByGuid(id);
    getOriginators();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onBlurField = () => {
    const _principal = isNaN(principal) || !principal ? 0 : principal;
    const _interest = isNaN(interest) || !interest ? 0 : interest;
    const _fees = isNaN(fees) || !fees ? 0 : fees;

    changeSolvenPaidParts(_principal, _interest, _fees);
  };

  const registerPayment = () => {
    for (let i = 0; i < solvenLoans.data.length; i++) {
      const loan = solvenLoans.data[i];
      const totalRemainingPrincipal = loan.RemainingAmount - loan.Principal;

      setTimeout(() => {
        registerMPLRepayment(
          loan.OriginatorCreditId,
          number,
          date,
          loan.Principal,
          loan.Interest,
          loan.Fees,
          totalRemainingPrincipal,
          loan.OriginatorId,
          creditEnded,
        );
      }, i * 500);
    }
  };

  const setEndedCheckbox = (value) => {
    if (value) {
      const totalPrincipalAmount = _.reduce(
        solvenLoans.data,
        (memo, item) => {
          return memo + item.RemainingAmount;
        },
        0,
      );
      const _interest = isNaN(interest) || !interest ? 0 : interest;
      const _fees = isNaN(fees) || !fees ? 0 : fees;

      setPrincipal(totalPrincipalAmount);
      changeSolvenPaidParts(totalPrincipalAmount, _interest, _fees);
    }
    setCreditEnded(value);
  };

  return (
    <div>
      <div className="accounting-layout body-height" style={wrapperStyle}>
        <div style={halfItemStyle}>
          <Card style={{ height: "100%" }}>
            <CardHeader title="Register solven payment" subheader={" "} />
            <CardContent>
              <DatePicker
                inputVariant="outlined"
                className="small-datepicker"
                value={date}
                onChange={(ev) => {
                  setDate(ev.target.value);
                }}
                fullWidth={true}
                label="Bank registered date"
              />
              <br />
              <CurrencyFormater
                disabled={creditEnded}
                value={principal}
                onBlur={onBlurField}
                onChange={(ev) => {
                  setPrincipal(ev.target.value);
                }}
                fullWidth={true}
                label="Principal"
              />
              <br />
              <CurrencyFormater
                value={interest}
                onBlur={onBlurField}
                onChange={(ev) => {
                  setInterest(ev.target.value);
                }}
                fullWidth={true}
                label="Interest"
              />
              <br />
              <CurrencyFormater
                value={fees}
                onBlur={onBlurField}
                onChange={(ev) => {
                  setFees(ev.target.value);
                }}
                fullWidth={true}
                label="Fees"
              />
              <br />
              <TextField
                size="small"
                variant="outlined"
                value={number}
                onBlur={onBlurField}
                onChange={(ev) => {
                  setNumber(ev.target.value);
                }}
                fullWidth={true}
                label="Number of the repayment"
                type="number"
              />
              <br />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={creditEnded}
                    onClick={(ev) => {
                      setEndedCheckbox(ev.target.checked);
                    }}
                  />
                }
                label="Credit ended"
              />
            </CardContent>
            <CardActions>
              <Button
                variant="contained"
                color="primary"
                onClick={registerPayment}
              >
                Register
              </Button>
            </CardActions>
            <TableNew
              columns={columns}
              items={solvenLoans.data}
              tableKey="SolvenRegister"
            />
          </Card>
          <Card></Card>
        </div>
      </div>
    </div>
  );
};

export default compose(accountingConnector)(AccountingSolvenComponent);
